export function formatTemplate(
  template: string,
  replacements: Map<string, string>,
  missingReplacement?: (key: string) => void
): string {
  const parts = getTemplateParts(template)
  const result: string[] = []

  for (const part of parts) {
    if (part.startsWith("{") && part.endsWith("}")) {
      const key = part.slice(1, -1)
      const replacement = replacements.get(key)
      if (replacement !== undefined) {
        result.push(replacement)
      } else {
        if (missingReplacement) {
          missingReplacement(key)
        }
        result.push(part)
      }
    } else {
      result.push(part)
    }
  }

  return result.join("")
}

function getTemplateParts(template: string): string[] {
  const parts: string[] = []
  let currentPartBuilder = ""

  for (const char of template) {
    switch (char) {
      case "{": {
        parts.push(currentPartBuilder)
        currentPartBuilder = char
        break
      }
      case "}": {
        currentPartBuilder += char
        parts.push(currentPartBuilder)
        currentPartBuilder = ""
        break
      }
      default: {
        currentPartBuilder += char
        break
      }
    }
  }

  if (currentPartBuilder.trim().length > 0) {
    parts.push(currentPartBuilder)
  }

  return parts
}